import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import classNames from 'classnames'
import InlineVideo from '@hashicorp/react-components/src/components/inline-video'
import EventTitle from 'components/_page-components/events/event-title'
import TopicContent from 'components/_page-components/events/topic-content'
import Agenda from 'components/_page-components/events/agenda'
import Tags from 'components/_page-components/events/tags'
import SpeakerList from 'components/_page-components/events/speaker-list'
import GatedWebinarMarketoForm from 'components/_page-components/events/gated-webinar-marketo-form'
import s from './style.module.css'

export default function Recorded({
	title,
	tagLine,
	partnerLogos,
	product,
	videoUrl,
	description,
	content,
	agenda,
	speakers,
	tags,
	webinarId,
	recordingGated,
	marketoForm,
}) {
	const localStorageKey = `gated-webinar-submission-${webinarId}`
	const hasDetailContent = content || agenda || tags?.length > 0

	const [userHasSubmittedGatedForm, setUserHasSubmittedGatedForm] = useState(
		typeof window !== 'undefined' &&
			window.localStorage.getItem(localStorageKey) === 'submitted'
	)
	const [gatedOverride, setGatedOverride] = useState(false)

	const searchParams = useSearchParams()

	useEffect(() => {
		if (searchParams.get('gated') === 'swap') {
			// ?gated="swap" should switch this webinar's `gated` state
			setGatedOverride(true)
		}
	}, [searchParams.get('gated')])
	// Ensure we re-render if userHasSubmittedGatedForm changes
	useEffect(() => {
		if (userHasSubmittedGatedForm === true) {
			setGatedOverride(true)
		}
	}, [userHasSubmittedGatedForm])

	function setGatedOverrideAndStorage() {
		window?.localStorage.setItem(localStorageKey, 'submitted')
		setGatedOverride(false)
		setUserHasSubmittedGatedForm(true)
	}
	function shouldBeGated() {
		if (userHasSubmittedGatedForm) return false // should not be gated regardless of query string if previously submitted
		return gatedOverride === true ? !recordingGated : !!recordingGated
	}
	return (
		<div className={s.recordedWebinarPage}>
			<div className={s.pageLane}>
				<section className={s.contentLane}>
					<div className={s.eventInfo}>
						<EventTitle
							title={title}
							partnerLogos={partnerLogos}
							tagLine={tagLine}
							type="recorded"
						/>

						{description ? (
							<div
								className={classNames(
									'g-type-body',
									s.description,
									shouldBeGated() && s.gated
								)}
								dangerouslySetInnerHTML={{ __html: description }}
							/>
						) : null}
					</div>

					{shouldBeGated() ? (
						<div className={s.webinarForm}>
							<GatedWebinarMarketoForm
								product={product}
								title={title}
								marketoForm={marketoForm}
								onSubmitSuccess={() => setGatedOverrideAndStorage()}
							/>
						</div>
					) : (
						<div className={s.video}>
							<InlineVideo gradientPosition={false} url={videoUrl} />
						</div>
					)}
				</section>

				<div
					className={classNames(
						s.webinarDetails,
						hasDetailContent && s.reverseMobile
					)}
				>
					{hasDetailContent ? (
						<div className={s.details}>
							{content && <TopicContent content={content} />}
							{agenda && <Agenda title={agenda.headline} items={agenda.rows} />}
							<Tags tags={tags} />
						</div>
					) : (
						<h4 className={s.presentersHeading}>Presenters</h4>
					)}

					<div className={s.aside}>
						{hasDetailContent ? (
							<h4 className={classNames(s.presentersHeading, s.asideHeading)}>
								Presenters
							</h4>
						) : null}
						<SpeakerList speakers={speakers} className={s.speakerList} />
					</div>
				</div>
			</div>
		</div>
	)
}
